export default function () {
  const route = useRoute()
  const routeBaseName = useRouteBaseName()
  const pageType = computed(() => (typeof route.meta.pageType === 'string' ? route.meta.pageType : ''))
  const localeStore = useLocaleStore()
  const siteLanguage = localeStore.selectedLanguage

  const base = computed(() => ({
    event: 'index_page_events',
    site_language: siteLanguage,
    page_type: pageType.value
  }))

  function pushIndexPageDataLayer(data: object) {
    if (pageType.value !== 'index') return

    pushToDataLayer({
      ...base.value,
      ...data
    })
  }

  function pushBestBuyBannerDataLayer(data: object) {
    pushIndexPageDataLayer({
      generic_event_name: 'best_buy_banner_section',
      event_category: 'best_buy_banner',
      ...base.value,
      ...data
    })
  }

  function pushBestBuyBannerNavigationDataLayer(data: object) {
    pushIndexPageDataLayer({
      generic_event_name: 'best_buy_banner_section',
      event_category: 'navigation_arrows',
      event_action: 'click',
      ...base.value,
      ...data
    })
  }

  function pushFormPromoBannerDataLayer(data: object) {
    pushIndexPageDataLayer({
      generic_event_name: 'fsf_promo_banner',
      event_category: 'clicks',
      ...base.value,
      ...data
    })
  }

  function pushSellingPointsSectionDataLayer(data: object) {
    if (routeBaseName(route) !== 'index') return

    pushIndexPageDataLayer({
      generic_event_name: 'selling_points',
      event_category: 'section',
      ...base.value,
      ...data
    })
  }

  function pushTrendingRoutesSectionDataLayer(data: object) {
    pushIndexPageDataLayer({
      generic_event_name: 'trending_routes',
      ...base.value,
      ...data
    })
  }

  function pushAppPromoBannerDataLayer(data: object) {
    pushIndexPageDataLayer({
      generic_event_name: 'app_promo_banner',
      ...base.value,
      ...data
    })
  }

  function pushCountdownDataLayer(data: object) {
    pushIndexPageDataLayer({
      ...base.value,
      event: 'countdown',
      event_label: 'grab_out',
      ...data
    })
  }

  function pushSubscribePopupDataLayer(data: object) {
    pushIndexPageDataLayer({
      ...base.value,
      generic_event_name: 'subscription_popup',
      ...data
    })
  }

  return {
    pushIndexPageDataLayer,
    pushFormPromoBannerDataLayer,
    pushSellingPointsSectionDataLayer,
    pushCountdownDataLayer,
    pushTrendingRoutesSectionDataLayer,
    pushBestBuyBannerDataLayer,
    pushAppPromoBannerDataLayer,
    pushSubscribePopupDataLayer,
    pushBestBuyBannerNavigationDataLayer
  }
}
